<script>
export default {
  props: {
    module: {
      type: Object,
    },
  },
};
</script>
<template>
  <FBody
    type="line"
    :module="module"
    @submit="$emit('submit')"
  >
    <FItem
      :module="module.dateFrom"
      width="90px"
      shrink="0"
    />
    <FItem
      :module="module.dateTo"
      width="90px"
      shrink="0"
    />
    <FItem
      :module="module.time"
      width="70px"
      shrink="0"
    />
    <FItem
      :module="module.days"
      width="170px"
      shrink="0"
    />
    <FItem
      :module="module.tariffs"
    />
    <FItem
      :module="module.quota"
      width="100px"
      shrink="0"
    />
    <FItem
      :module="module.accept"
      class="f-item--border"
      title="Действительный"
      width="24px"
      shrink="0"
    />
    <FBtn
      icon="el-icon-delete"
      width="24px"
      shrink="0"
      title="Удалить"
      @click="$emit('remove', module)"
    />
  </FBody>
</template>
<style lang="scss">

</style>
